import React from 'react';
import './Calculator.css';

const Quote = () => (
  <div>
    <p className="quote">
      Mathematics is not about numbers, equations, computations, or algorithms:
      it is about understanding. - William Paul Thurston
    </p>
  </div>
);

export default Quote;
